import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  FormControl,
  FormLabel,
  InputGroup,
  FormErrorMessage,
  Textarea,
  useDisclosure,
  Text,
  Box,
  useToast,
} from "@chakra-ui/react";
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { onUpdateOrderNotes } from "../../../api/orders";

export function OrderNotes({ row, setOpenLoader, fetchData, filterQuery }) {
  const finalRef = React.useRef(null);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { register, handleSubmit, formState, setValue, watch, reset } = useForm(
    {
      defaultValues: {
        note: "",
      },
    }
  );

  useEffect(() => {
    register("note", {
      required: "notes is required",
      validate: (value) =>
        value.trim().length > 0 && value.trim().length < 150
          ? true
          : "Invalid notes",
    });
  }, [isOpen]);

  const { errors, isDirty } = formState;
  const form = watch();
  const toast = useToast();

  const onCloseModal = () => {
    onClose();
    reset();
    fetchData(filterQuery);
  };

  const handelSubmit = async (data) => {
    setOpenLoader(true);
    const body = {
      ...data,
      order_id: row.orderId,
    };
    const res = await onUpdateOrderNotes(body, toast);
    if (res) {
      toast({
        status: "success",
        title: "",
        description: "Updated successfully",
      });
      onCloseModal();
    }
    setOpenLoader(false);
  };

  const onError = (errors) => console.log(errors);

  return (
    <>
      <Box
        display={"flex"}
        alignItems={"center"}
        width={"100%"}
        cursor={"pointer"}
        onClick={onOpen}
      >
        <Text onClick={onOpen}>Support Notes</Text>
      </Box>
      <Modal
        isCentered
        finalFocusRef={finalRef}
        isOpen={isOpen}
        onClose={onCloseModal}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Support Notes</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <FormControl isRequired isInvalid={!!errors.note}>
              <FormLabel fontSize={12} fontWeight={"semibold"}>
                Notes
              </FormLabel>
              <InputGroup>
                <Textarea
                  placeholder="Enter Notes"
                  type="string"
                  value={form["note"]}
                  onChange={(e) => setValue("note", e.target.value)}
                />
              </InputGroup>
              <FormErrorMessage>{errors?.note?.message}</FormErrorMessage>
            </FormControl>
          </ModalBody>

          <ModalFooter gap={4}>
            <Button
              colorScheme="white"
              color={"#3182ce"}
              size="sm"
              onClick={onCloseModal}
            >
              Cancel
            </Button>
            <Button
              onClick={handleSubmit(handelSubmit, onError)}
              size="sm"
              color={"white"}
              colorScheme="blue"
            >
              Save
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
